import { createReducer, on } from '@ngrx/store';
import { CardActiveInstalmentAgreements } from 'src/app/models/card-active-instalment-agreements.model';
import { InstalmentAgreementDetails } from 'src/app/models/card-instalment-agreement-details.model';
import { CardInstalmentAgreements } from 'src/app/models/card-instalment-agreements.model';
import { CardStatementsFilter } from 'src/app/models/card-statements-filter.model';
import { CardTransaction } from 'src/app/models/card-transaction.model';
import { Card } from 'src/app/models/card.model';
import {
  createServerDate,
  generateFutureDate,
  generatePastDate
} from 'src/app/shared/utils/date.utils';
import * as fromCardsActions from '../../actions/cards/cards.actions';
import { CardStatement } from './../../../models/card-account-statement.model';
import { TransactionHistoryList } from './../../../models/transaction-history.model';

export const cardsFeatureKey = 'cards';

export interface State {
  selectedCard: Card | null;
  transactionHistory: CardTransaction | null;
  transactionHistoryList: TransactionHistoryList | null;
  statements: CardStatement[] | null;
  cardStatementsFilters: CardStatementsFilter;
  instalmentAgreements: CardInstalmentAgreements | null;
  activeInstalmentAgreements: CardActiveInstalmentAgreements | null;
  cardInstalAgreementsDetails: InstalmentAgreementDetails | null;
}

export const initialState: State = {
  selectedCard: null,
  transactionHistoryList: null,
  transactionHistory: null,
  statements: null,
  cardStatementsFilters: {
    to: createServerDate(generateFutureDate(0, 0, 0).toString()),
    from: createServerDate(generatePastDate(1, 3, 0).toString())
  },
  instalmentAgreements: null,
  activeInstalmentAgreements: null,
  cardInstalAgreementsDetails: null
};

export const reducer = createReducer(
  initialState,
  on(
    fromCardsActions.layoutSelectActiveCard,
    fromCardsActions.cardsComponentSelectActiveCard,
    (state, action) => {
      return {
        ...state,
        selectedCard: action.selectedCard
      };
    }
  ),
  on(fromCardsActions.loadTransactionHistorySuccess, (state, action) => {
    return {
      ...state,
      transactionHistory: action.cardTransactions
    };
  }),

  on(fromCardsActions.setCardTransactionDetails, (state, action) => {
    return {
      ...state,
      transactionHistoryList: action.cardTransactionDetails
    };
  }),
  on(fromCardsActions.setCardInstalAgreementDetails, (state, action) => {
    return {
      ...state,
      cardInstalAgreementsDetails: action.cardInstalAgreementsDetails
    };
  }),
  on(fromCardsActions.loadCardAccStatementsSuccess, (state, action) => {
    return {
      ...state,
      statements: action.cardAccStatements,
      error: null
    };
  }),
  on(fromCardsActions.resetCardAccStatements, (state, action) => {
    return {
      ...state,
      statements: null,
      error: null
    };
  }),
  on(fromCardsActions.loadCardAccStatementsFailure, (state, action) => {
    return {
      ...state,
      statements: null,
      error: action.error
    };
  }),
  on(fromCardsActions.cardFilterStatements, (state, action) => {
    let filtersApplied = 0;
    const formVal = action.cardStatementsFilters;
    Object.keys(formVal).map((key: string) => {
      switch (key) {
        case 'from':
          formVal[key] !==
          createServerDate(generatePastDate(1, 1, 0).toString())
            ? filtersApplied++
            : '';
          break;
        case 'to':
          formVal[key] !==
          createServerDate(generateFutureDate(0, 0, 0).toString())
            ? filtersApplied++
            : '';
          break;
        default:
          (formVal as any)[key] ? filtersApplied++ : '';
      }
    });
    return {
      ...state,
      cardStatementsFilters: action.cardStatementsFilters,
      filtersApplied
    };
  }),
  on(fromCardsActions.resetFilterStatements, state => {
    return {
      ...state,
      cardStatementsFilters: {
        to: createServerDate(generateFutureDate(0, 0, 0).toString()),
        from: createServerDate(generatePastDate(1, 3, 0).toString())
      },
      filtersApplied: 0
    };
  }),
  on(fromCardsActions.loadInstalmentAgreementsSuccess, (state, action) => {
    return {
      ...state,
      instalmentAgreements: action.instalmentAgreements,
      error: null
    };
  }),
  on(
    fromCardsActions.loadActiveInstalmentAgreementsSuccess,
    (state, action) => {
      return {
        ...state,
        activeInstalmentAgreements: action.activeInstalmentAgreements,
        error: null
      };
    }
  )
);
